import {
    Chart,
} from 'chart.js';

export const initChart = ($this, preExistingChart, args) => {
        let {limit, total, chartId, labels, isBytes} = args;
        if (preExistingChart) {
            preExistingChart.destroy();
        }
        const toolTip = (tooltipItems) => {
            let sum = 0;
            tooltipItems.forEach(function (tooltipItem) {
                sum += tooltipItem.parsed;
            });

            return isBytes ? $this.getReadableFileSize(sum) : "";
        };

        const el = document.getElementById(chartId);
        let ctx;
        try {
            ctx = el.getContext('2d');
        } catch {
            console.log(chartId + ' could not be initialized')
            return;
        }
        const config = {
            type: 'pie',
            data: {
                labels: labels,
                datasets: [{
                    label: 'Free',
                    data: [limit - total < 0 ? 0 : limit - total, total], //todo
                    backgroundColor: ['#60b66f', '#e1def3'],
                    borderColor: 'transparent',
                }]
            },
            options: {
                responsive: true,
                color: '#fff',
                plugins: {
                    legend: {
                        position: 'top',
                    },
                    title: {
                        display: false,
                        text: 'Storage',
                        color: '#fff',
                    },
                    tooltip: {
                        callbacks: {
                            footer: toolTip,
                        }
                    }
                }
            },
        };
        return new Chart(ctx, config);
}